import { ComponentProps } from "react";

import { ClassName } from "config";

import classNames from "classnames";
import { motion, Transition } from "framer-motion";

import { FadeTransitionImage } from "./FadeTransitionImage";

export const MotionImage = motion.img;

type TransitionType = "fade";

export type TransitionImageProps = ComponentProps<typeof MotionImage>;

interface IProps extends Omit<TransitionImageProps, "className"> {
  className?: ClassName;
  type?: TransitionType;
}
export const TransitionImage: React.FC<IProps> = ({
  type = "fade",
  transition,
  className,
  ...rest
}) => {
  const defaultTransition: Transition = {
    type: "tween",
    duration: 0.5,
    delay: 0,
  };

  const transitionSettings = { ...defaultTransition, ...transition };

  const classes = classNames("transition-image", className);

  const componentProps = {
    ...rest,
    className: classes,
    transition: transitionSettings,
  };

  switch (type) {
    case "fade": {
      return <FadeTransitionImage {...componentProps} />;
    }
    default: {
      return null;
    }
  }
};
